document.addEventListener('DOMContentLoaded', () => {
  const revealSooner = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      revealSooner.unobserve(entry.target);
    });
  }, { threshold: 0.01, rootMargin: '0px 0px 18%' });

  document.querySelectorAll('.reveal, .media-reveal').forEach((element) => revealSooner.observe(element));

  const formatMoney = (cents) => new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR'
  }).format(Number(cents || 0) / 100);

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    const experience = select.closest('[data-product-experience]');
    const form = select.closest('.product-form');
    const price = experience?.querySelector('[data-product-price]');
    const compare = experience?.querySelector('[data-product-compare]');
    const saving = experience?.querySelector('[data-product-saving]');
    const button = form?.querySelector('.product-atc');
    const label = form?.querySelector('[data-atc-label]');
    const mobilePrice = experience?.querySelector('[data-mobile-price]');
    const mobileCompare = experience?.querySelector('[data-mobile-compare]');

    const updateVariant = () => {
      const option = select.selectedOptions[0];
      if (!option) return;
      const priceValue = Number(option.dataset.price || 0);
      const compareValue = Number(option.dataset.comparePrice || 0);
      const available = option.dataset.available !== 'false';
      if (price) price.textContent = formatMoney(priceValue);
      if (compare) {
        compare.textContent = compareValue > priceValue ? formatMoney(compareValue) : '';
        compare.hidden = compareValue <= priceValue;
      }
      if (saving) {
        saving.textContent = compareValue > priceValue ? `Vous économisez ${formatMoney(compareValue - priceValue)}` : '';
        saving.hidden = compareValue <= priceValue;
      }
      if (mobilePrice) mobilePrice.textContent = formatMoney(priceValue);
      if (mobileCompare) {
        mobileCompare.textContent = compareValue > priceValue ? formatMoney(compareValue) : '';
        mobileCompare.hidden = compareValue <= priceValue;
      }
      if (button) button.disabled = !available;
      if (label) label.textContent = available ? `Ajouter au panier · ${formatMoney(priceValue)}` : 'Indisponible';
    };

    select.addEventListener('change', updateVariant);
    updateVariant();
  });

  document.querySelectorAll('[data-select-bundle]').forEach((button) => {
    button.addEventListener('click', () => {
      const experience = button.closest('[data-product-experience]');
      const select = experience?.querySelector('[data-variant-select]');
      if (!select) return;
      select.value = button.dataset.variantId;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      select.closest('.product-form')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => select.focus({ preventScroll: true }), 450);
    });
  });

  document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-carousel-track]');
    const slides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
    const previous = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    const current = carousel.querySelector('[data-carousel-current]');
    const total = carousel.querySelector('[data-carousel-total]');
    const progress = carousel.querySelector('[data-carousel-progress]');
    if (!track || !slides.length) return;

    let activeIndex = 0;
    let frame = 0;
    const pad = (value) => String(value).padStart(2, '0');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const update = () => {
      const trackLeft = track.getBoundingClientRect().left;
      activeIndex = slides.reduce((closest, slide, index) => {
        const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
        return distance < closest.distance ? { index, distance } : closest;
      }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;
      if (current) current.textContent = pad(activeIndex + 1);
      if (total) total.textContent = pad(slides.length);
      if (progress) progress.style.transform = `scaleX(${(activeIndex + 1) / slides.length})`;
      if (previous) previous.disabled = activeIndex === 0;
      if (next) next.disabled = activeIndex === slides.length - 1;
    };

    const goTo = (index) => {
      const targetIndex = Math.max(0, Math.min(index, slides.length - 1));
      const trackPadding = Number.parseFloat(window.getComputedStyle(track).paddingLeft) || 0;
      track.scrollTo({
        left: slides[targetIndex].offsetLeft - track.offsetLeft - trackPadding,
        behavior: prefersReducedMotion.matches ? 'auto' : 'smooth'
      });
    };

    previous?.addEventListener('click', () => goTo(activeIndex - 1));
    next?.addEventListener('click', () => goTo(activeIndex + 1));
    track.addEventListener('scroll', () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(update);
    }, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(activeIndex - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); goTo(activeIndex + 1); }
    });
    window.addEventListener('resize', update, { passive: true });
    update();
  });
});
